exports.linkResolver = (doc) => {
  // URL for a category type

  // Backup for all other types
  return '/'
}